import React, { ReactElement } from "react";
import { ListTableColumn, renderEnumValue, Stack } from "sprint-common-web";

import { RecordType } from "../types/RecordType";

export const renderRecordType = <T,>(item?: T, _index?: number, column?: ListTableColumn<T>): ReactElement | null => {
    return <Stack data-testid="record-type">{renderEnumValue(RecordType, item, _index, column)}</Stack>;
};
